import { underline as underline_1 } from './underline.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleUnderline } from 'roosterjs-editor-api';

const underline: RibbonButton = {
    key: 'underline',
    title: () => loc(underline_1),
    imageSrc: require('../svg/underline.svg'),
    shortcut: 'ctrl+U',
    buttonState: formatState =>
        formatState.isUnderline ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleUnderline(plugin.getEditor()),
};

export default underline;
